var GOOGLE_MAP_KEY = 'AIzaSyDvgMpLFrIULFqDQHujudX19wXXZO06tMc';
var GOOGLE_MAP_NON_REFERER_KEY = 'AIzaSyBeuf0sfV2LOJ8uQDX9VHmNqbDsINjSW5s';
export { GOOGLE_MAP_KEY, GOOGLE_MAP_NON_REFERER_KEY };
